<template>
    <v-main>
        <v-layout fill-height column>
            <v-container fluid flex-fill>
                <h1 class="logo">로고</h1>
                <v-form class="form-item" v-model="valid">
                    <label class="label fw-600">이메일</label>
                    <div class="input-group">
                        <v-text-field solo flat filled
                            v-model="email"
                            required
                            placeholder="이메일 주소"
                        />
                    </div>
                    <label class="label fw-600">비밀번호</label>
                    <div class="input-group">
                        <v-text-field solo flat filled
                            v-model="password"
                            type="password"
                            required
                            placeholder="비밀번호"
                        />
                    </div>
                </v-form>
                <BlackBtn str="로그인" />
                <div class="d-flex align-center justify-end mt-2">
                    <v-btn text plain :ripple="false" min-width="20" class="fs-14 secondary--text fw-400 pa-0" @click="sheetOpen()">회원가입</v-btn>
                    <span class="line"></span>
                    <v-btn text plain :ripple="false" min-width="20" class="fs-14 secondary--text fw-400 pa-0" @click="goFindIdPage">아이디 찾기</v-btn>
                    <span class="dot"></span>
                    <v-btn text plain :ripple="false" min-width="20" class="fs-14 secondary--text fw-400 pa-0" @click="goFindPasswdPage">비밀번호 찾기</v-btn>
                </div>
            </v-container>
            <v-footer grow class="content-footer">
                    <div class="content-footer__head"><span>또는</span></div>
                    <div class="content-footer__contents">
                        <v-btn icon plain :ripple="false" max-width="44" min-width="44"><img :src="getImage('ic_kakao2.svg')"></v-btn>
                        <v-btn icon plain :ripple="false" max-width="44" min-width="44"><img :src="getImage('ic_narver.svg')"></v-btn>
                        <v-btn icon plain :ripple="false" max-width="44" min-width="44"><img :src="getImage('ic_google.svg')"></v-btn>
                        <v-btn icon plain :ripple="false" max-width="44" min-width="44"><img :src="getImage('ic_apple.svg')"></v-btn>
                    </div>
            </v-footer>
        </v-layout>
        <MemberTypeSheet :sheet="sheet" @sheetClose="sheetClose" />
    </v-main>
</template>
<script>
import BlackBtn from "@/components/btns/BlackBtn"
import MemberTypeSheet from "@/components/layout/bottomSheet/MemberTypeSheet"

export default {
    data: () => ({
        email: '',
        password: '',
        valid: false,
        sheet: false,
    }),
    components: {
        BlackBtn,
        MemberTypeSheet,
    },
    methods: {
        sheetClose() {
            this.sheet = false;
        },
		sheetOpen() {
			this.sheet = true;
		},
		goFindIdPage() {
			this.$router.push({name: '아이디 찾기'})
		},
		goFindPasswdPage() {
			this.$router.push({name:'비밀번호 찾기'})
		}

    }
}
</script>
<style lang="scss" scoped>
.logo {
    text-align: center;
    padding: 25px 0 60px;
}
.line {
    width:1px;
    height: 12px;
    background: #9FA3A8;
    margin: 0 12px;
}
.dot {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #9FA3A8;
    margin: 0 6px;
}
.content-footer {
    padding: 0 20px;
    flex-direction: column;
    height: auto !important;
    &__head{
        position: relative;
        text-align: center;
        span{
            position: relative;
            color: $color-gray-3 ;
            background: #fff;
            padding: 0 8px;
            z-index: 1;
            font-size: 14px;
        }
        &:after {
            position: absolute;
            display: inline-block;
            content: '';
            width: 100%;
            height: 1px;
            top: 50%;
            left: 0;
            background: #E6E8EA;

        }
    }
    &__contents{
        display: flex;
        justify-content: center;
        gap: 16px;
        padding: 30px 0 60px;
    }
}
</style>
